export class FindProviderGroupDetailsRequest {    
    public providerGroupId: string;
  }
  